module.exports = __webpack_public_path__ + "img/logo1.278a76ea.png";